module.exports = __webpack_public_path__ + "static/sala.d861392c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sala.jpg
// module id = 541
// module chunks = 117206707316740